import { ExperimentTwoTone } from "@ant-design/icons";
import styles from "./BetaMessage.module.scss";

interface BetaMessageProps {
  title?: React.ReactNode;
  children: React.ReactNode;
}

export default function BetaMessage({ title, children }: BetaMessageProps) {
  return (
    <div className={styles.BetaMessage}>
      <ExperimentTwoTone />
      <div className={styles.message}>
        <div className={styles.title}>{title}</div>
        <div className={styles.message}>{children}</div>
      </div>
    </div>
  );
}
